import { TextField, styled } from "@mui/material";

// CustomTextField styled to match input style

// Customize MenuProps to control dropdown behavior
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: "55%",
      overflowY: "auto",
      color: "#000000",
    },
  },
};

const CustomField = ({ value, width, disabled, placeholder }) => {
  const CustomTextField = styled(TextField)(({ theme, error }) => ({
    width: width || "9.5rem",
    "& .MuiInputBase-root": {
      height: "40px",
      p: 0,

      backgroundColor: "#FFFFFF", // Ensures background remains white
      color: "#000000", // Ensures text color remains normal
    },
    "& .Mui-disabled": {
      backgroundColor: "#FFFFFF", // Override default MUI gray background
      color: "#000000", // Text should not be grayed out
      WebkitTextFillColor: "#000000", // Ensures text remains visible in WebKit browsers
      opacity: 1, // Ensures full visibility
    },
    ...(error && {
      "& .MuiOutlinedInput-root": {
        "&:hover": {
          borderColor: "#D34040",
        },
        "&.Mui-focused": {
          borderColor: "#D34040",
        },
      },
    }),
  }));

  return (
    <CustomTextField
      value={value}
      disabled={disabled}
      fullWidth
      variant="outlined"
      SelectProps={{ MenuProps }}
      placeholder={placeholder}
    />
  );
};

export default CustomField;